import { useCallback, useMemo, useState } from "react";

import { ScrollContainer } from "app/components/layout/ScrollContainer";
import { DEFAULT_HOMEPAGE_PREFERENCE_KEY, DIGITAL_SUITE_HOMEPAGES } from "app/components/modals/constants";
import { DefaultHomePageModal } from "app/components/modals/DefaultHomePageModal";
import { AeoHomePage } from "app/pages/digital-suite/home-page/AeoHomePage";
import { DigitalSuiteAfterTrialHomePage } from "app/pages/digital-suite/home-page/DigitalSuiteAfterTrialHomePage";
import { DigitalSuiteMarketingHomePage } from "app/pages/digital-suite/home-page/DigitalSuiteMarketingHomePage";
import { DigitalSuiteNewHomePage } from "app/pages/digital-suite/home-page/DigitalSuiteNewHomePage";
import { isAeoHomepage, isNewHomepage } from "app/pages/digital-suite/home-page/helpers";
import { PreferencesService } from "app/services/preferences/preferencesService";
import { isAfterTrial, isTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";
import { allTrackers } from "app/services/track/track";

const DEFAULT_HOMEPAGE = DIGITAL_SUITE_HOMEPAGES.DMI;

export const DigitalSuiteHomePageContainer = (props) => {
    const defaultSelectedHomepage = PreferencesService.get(DEFAULT_HOMEPAGE_PREFERENCE_KEY);
    const [currentHomePage, setCurrentHomepage] = useState(defaultSelectedHomepage || DEFAULT_HOMEPAGE);
    const nextHomePage = useMemo(() => {
        return currentHomePage === DIGITAL_SUITE_HOMEPAGES.DMI
            ? DIGITAL_SUITE_HOMEPAGES.MRI
            : DIGITAL_SUITE_HOMEPAGES.DMI;
    }, [currentHomePage]);

    const onHomepageButtonClick = useCallback(async () => {
        try {
            setCurrentHomepage(nextHomePage);
            await PreferencesService.add({
                [DEFAULT_HOMEPAGE_PREFERENCE_KEY]: nextHomePage,
            });
            allTrackers.dispatchTrackEvent(
                "Button",
                "click",
                `Set ${currentHomePage || ""} as default homepage from homepage button`,
            );
        } catch (e) {}
    }, [currentHomePage, nextHomePage]);

    const HomePageComponent = useMemo(() => {
        if (isAeoHomepage()) {
            return AeoHomePage;
        }
        // for after trial we want different homepage
        if (isAfterTrial()) {
            return DigitalSuiteAfterTrialHomePage;
        } // after-trial
        if (isNewHomepage()) {
            return DigitalSuiteNewHomePage;
        } // trial or NT
        return DigitalSuiteMarketingHomePage;
    }, [currentHomePage]);

    const showDefaultHomePageModal = !defaultSelectedHomepage && !isTrialOrAfterTrial();

    return (
        <ScrollContainer>
            {showDefaultHomePageModal ? (
                <DefaultHomePageModal
                    defaultHomepage={defaultSelectedHomepage}
                    onSelectDigitalSuiteHomePage={(page) => setCurrentHomepage(page)}
                />
            ) : null}
            <HomePageComponent
                onHomepageButtonClick={onHomepageButtonClick}
                hasAvailableAllocations={props.hasAvailableAllocations}
            />
        </ScrollContainer>
    );
};
